module.exports = __webpack_public_path__ + "media/icons/chevron-blue-426a8863.svg";